export default {
    SIDEBAR_TITLE: "Добавить",
    SORT_BY_TITLE: "По названию",
    NO_SUMMARY_REPORT_OBJECTS: "В сводке нет объектов"
};
